// extracted by mini-css-extract-plugin
export default {"container":"NigzO1qb_gsKtU8vnRwu","box":"HSvemp57YGxEfTOC5zTZ","inner":"errWEJSo1VIcQdKoUBZS","icon":"G5yuC8Q1D06LJxCrcKUN","text":"Fc_sEZ5wHDVeC62Kdkbg"};